<div class="body">
    <div class="afiliado">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-4">
                    <h1> Pagos Préstamos {{tipoPostulacion}} </h1>
                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Asignadas'">

                    <button class="btn btn-info" (click)="postulacionesDisponiblesBuscador()"> Solicitudes Disponibles </button>
                </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Disponibles'">

                    <button class="btn btn-info" (click)="postulacionesAsignadas(true)"> Solicitudes Asignadas </button>

                </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">
                    <select class="form-control" (change)="buscar()" [(ngModel)]="buscador.itemsPerPage">
                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                    </select> </div>

            </div>
            <hr/> <br/>

            <div>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> RUT de Usuario: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="rut" class="form-control" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>
                    <div class="col-lg-2" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_CONTABILIDAD'"> 
                        <h3> Región: </h3>
                    </div>

                    <div class="col-lg-3" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_CONTABILIDAD'"> 

                        <mat-select [(ngModel)]="buscador.region" [disabled]="this.rol != 'ROLE_ADMINISTRADOR' && this.rol != 'ROLE_ENCARGADO_NACIONAL' && this.rol != 'ROLE_COORDINADOR' && this.rol != 'ROLE_ENCARGADO_CONTABILIDAD'  && this.rol != 'ROLE_CONTABILIDAD'">

                            <mat-option value="0">

                                SELECCIONE....

                            </mat-option>

                            <mat-option *ngFor="let region of regiones" value="{{region.id}}">

                                {{region.nombre}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> ID Solicitud: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input [(ngModel)]="buscador.idSolicitud" class="form-control" type="number" pattern="[0-9]" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Estados: </h3>
                    </div>

                    <div class="col-lg-3">
                        <mat-select [(ngModel)] = "buscador.estadoselect"  multiple  >
                              <mat-option *ngFor = "let esta of estado" value = "{{esta}}">
                                {{esta}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> ID Plan: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input [(ngModel)]="buscador.idPlanPago" class="form-control" type="number" pattern="[0-9]" />

                    </div>
                </div> <br/>


                <div class="row">

                    <div class="col-lg-2">
                        <h3> Fecha Inicio: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaInicio" class="form-control" type="date" #fechaInicio="ngModel" [(ngModel)]="buscador.fechaInicio" placeholder="Ingrese la fecha Inicio" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Fecha Fin: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaFin" class="form-control" type="date" #fechaFin="ngModel" [(ngModel)]="buscador.fechaFin" placeholder="Ingrese la fecha Fin" />

                    </div>

                    

                    <div class="col-lg-2"> <button class="btn btn-info" (click)="buscar()">

                        <i class = "fa fa-search"></i> Buscar </button>

                    </div>

                </div>
                <hr/> <br/>

                <div class="row" *ngIf="tipoPostulacion == 'Disponibles'">
                    <div class="col-lg-2">
                        <h3>
                            <mat-checkbox color="primary" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)"> Seleccionar Todo </mat-checkbox>
                        </h3>
                    </div>              
                    <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">
                        <div class="col-lg-2"> <button mat-button class="mat-raised-button btn-warning" (click)="asignarSeleccionados()">

                                <i class = "fa fa-pen"></i> Asignar Seleccionados </button>
                        </div>
                    </div>
                    <div class="col-lg-5"> </div>
                    <div class="col-lg-2">


                    </div>

                </div>

                <br/>

                <div class="table-responsive">

                    <table class="table" style="border: 1px;">

                        <thead style="background-color: #0f69b4;color:white;">

                            <tr>
                                <th> </th>

                                <th style="text-align: center;"> N° </th>
                                <th style="text-align: center;"> ID Solicitud </th>
                                <th style="text-align: center;"> RUT Solicitante</th>
                                <th style="text-align: center;"> Nombre Solicitante </th>
                                <th style="text-align: center;"> Tipo Préstamo</th>
                                <th style="text-align: center;"> Monto Solicitado </th>
                                <th style="text-align: center;"> Cuota a Pagar </th>

                                <th style="text-align: center;"> Fecha Pago </th>

                                <th style="text-align: center;"> Ejecutivo </th>
                                <th style="text-align: center;"> Estado </th>


                                <th style="text-align: center;"></th>
                            </tr>

                        </thead>

                        <tbody>
                            <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pago of pagosPrestamo | paginate: config; let i = index">
                                <td style="text-align: center;">
                                    <mat-checkbox [(ngModel)]="pago.seleccionado" color="primary" (ngModelChange)="updateAllComplete()"> </mat-checkbox>
                                </td>
                                <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialog(pago.idPlanPago, 4, false,false)"> {{pago.idPlanPago}}</a></td>
                                <td style="text-align: center;">{{pago.idPostulacion}}</td>
                                <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(pago.rutUsuario)" style="cursor:pointer; text-decoration: underline;"> {{pago.rutUsuario}} </a> </td>
                                <td style="text-align: center;">{{pago.nombreUsuario}} {{pago.apPatUsuario}}</td>
                                <td style="text-align: center;">{{pago.tipoPrestamo}}</td>
                                <td style="text-align: center;">{{pago.montoSolicitado}}</td>
                                <td style="text-align: center;">{{pago.montoTotal}}</td>
                                <td style="text-align: center;">{{pago.fechaAbono}}</td>
                                <td style="text-align: center;">{{pago.nombreEjecutivo}} {{pago.apPatEjecutivo}}</td>
                                <td style="text-align: center;">{{pago.estado}}</td>
                                <td style="text-align: center;">
                                    <button *ngIf="tipoPostulacion == 'Asignadas' && pago.estado == 'EN VALIDACION' " class="btn btn-success" (click)="openEditDialog(pago.idPlanPago, 4, true,false)" style="width: 120px">

                                        <i class = "fa fa-pen"> </i> Gestionar 
        
                                    </button>
                                    <button *ngIf="tipoPostulacion == 'Asignadas' && pago.estado != 'EN VALIDACION'" class="btn btn-warning" (click)="openEditDialog(pago.idPlanPago, 4, false,false)" style="width: 120px">
        
                                        <i class = "fa fa-pen"> </i> Revisar
        
                                    </button>
    
                                    <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">
                                        <button *ngIf="tipoPostulacion == 'Disponibles' && pago.estado != 'PAGADA' && pago.estado != 'ANULADA'
                                        && pago.estado == 'INGRESADA' 
                                        && ((this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD') && tipoPostulacion == 'Disponibles' && pago.estado != 'PAGADA')
                                        || (pago.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles' && (this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' ))
                                        || (pago.estado == 'VIGENTE' && tipoPostulacion == 'Disponibles' && (this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD'))
                                        || (pago.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles')
                                        ;else noAsigna
        
                                        " class="btn btn-warning" style="width: 120px" (click)="asignaPostulacion(pago.idPlanPago)">
        
                                            <i class = "fa fa-pen"> </i> Asignar
        
                                        </button>
                                    </div>
                                    <ng-template #noAsigna>
                                        <button *ngIf="tipoPostulacion == 'Disponibles'" class="btn btn-secondary" style="width: 120px" disabled>
                                       Sin acciones 
                                      </button>
                                    </ng-template>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>
                </div>
            </div>
        </div>
    </div>